import React, { memo } from "react";

// dls
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import { TitleBar } from "@swiggy-private/dls-web-core/dist/components/TitleBar";

// constant
import { DATA_TEST_IDS, DEFAULT_IMAGE_SRC, SIZE, TEXTS } from "./constant";

// styled components
import {
    ErrorContainer,
    HeadingWrapper,
    ImageComponent,
    RefreshButton,
    SubHeadingWrapper,
} from "./styled";

// type
import { IErrorComponentProps } from "./types";

const ErrorComponent = ({
    imgSrc,
    heading,
    description,
    ctaText,
    leftIcon,
    headerTitle,
    onCtaClick,
    showCta = true,
    showFullPage = true,
    ctaBtnType,
    titleVariant,
    descriptionVariant,
    titleColor,
    descriptionColor,
    imgWidth,
    imgHeight,
    containerWidth,
}: IErrorComponentProps) => {
    return (
        <div>
            <TitleBar title={headerTitle} leftIcon={leftIcon} removePadding={true} />
            <ErrorContainer showFullPage={showFullPage} containerWidth={containerWidth}>
                <ImageComponent
                    src={imgSrc || DEFAULT_IMAGE_SRC}
                    width={imgWidth || SIZE.IMAGE_WIDTH}
                    height={imgHeight || SIZE.IMAGE_HEIGHT}
                />
                <HeadingWrapper>
                    <Text
                        variant={titleVariant || "V2.subheading1.neutral.bold"}
                        color={titleColor || "text_Highest_Emphasis"}
                    >
                        {heading || TEXTS.HEADING}
                    </Text>
                </HeadingWrapper>
                <SubHeadingWrapper>
                    <Text
                        variant={descriptionVariant || "V2.body2.neutral.medium"}
                        color={descriptionColor || "text_Low_Emphasis"}
                    >
                        {description || TEXTS.DESCRIPTION}
                    </Text>
                </SubHeadingWrapper>
                {showCta && (
                    <RefreshButton
                        data-testId={DATA_TEST_IDS.REFRESH_CTA}
                        onClick={onCtaClick}
                        variant={ctaBtnType || "primary"}
                        buttonSize="large"
                    >
                        <Text variant="V2.body1.neutral.bold" color="text_Button_Primary">
                            {ctaText || TEXTS.REFRESH}
                        </Text>
                    </RefreshButton>
                )}
            </ErrorContainer>
        </div>
    );
};

export default memo(ErrorComponent);
